import axios from 'axios'
import { IAddressSuggestion } from '@/client/types'

export const getAddressSuggestions = async (query: string) => {
  // Trailing slash on purpose: next.config.js sets `trailingSlash: true`,
  // without it every call costs an extra 308 redirect.
  const { data } = await axios.get<{ suggestions: IAddressSuggestion[] }>('/api/address-autocomplete/', {
    params: { q: query }
  })
  return data?.suggestions ?? []
}
